var pubs = [

  {
    "linky":"../data/17-vast-vigor.pdf",
    "title":"VIGOR: Interactive Visual Exploration of Graph Query Results.",
    "authors": "Pienta, R.; Hohman, F.; Endert, A.; Tamersoy, A.; Roundy, K., Gates, C.; Navathe, S.; and Chau, D. H.",
    "rest": "In IEEE Transactions on Visualization and Computer Graphics (VAST). 2017.",
    "bibtex":`@ARTICLE{pienta2017vigor,
      author={R. Pienta and F. Hohman and A. Endert and A. Tamersoy and K. Roundy and C. Gates and S. Navathe and D. H. Chau},
      journal={IEEE Transactions on Visualization and Computer Graphics},
      title={VIGOR: Interactive Visual Exploration of Graph Query Results},
      year={2017},
      volume={PP},
      number={99},
      pages={1-1},
      doi={10.1109/TVCG.2017.2744898},
      ISSN={1077-2626}
    }`
  },

{
  "linky":"../data/17-sigmod-visage.pdf",
  "title":"Visual Graph Query Construction and Refinement.",
  "afterword": "[Best Demo: Honorable Mention]",
  "authors": "Pienta, R.; Hohman, F.; Tamersoy, A.; Endert, A.; Navathe, S.; Tong, H.; and Chau, D. H.",
  "rest": "In Proceedings of the ACM International Conference on Management of Data (SIGMOD). Pages 1587-1590, 2017.",
  "bibtex":`inproceedings{pienta2017visagedemo,
   author = {Pienta, Robert and Hohman, Fred and Tamersoy, Acar and Endert, Alex and Navathe, Shamkant and Tong, Hanghang and Chau, Duen Horng},
   title = {Visual Graph Query Construction and Refinement [Best Demo: Honorable Mention]},
   booktitle = {Proceedings of the 2017 ACM International Conference on Management of Data},
   series = {SIGMOD '17},
   year = {2017},
   isbn = {978-1-4503-4197-4},
   location = {Chicago, Illinois, USA},
   pages = {1587--1590},
   numpages = {4},
   url = {http://doi.acm.org/10.1145/3035918.3056418},
   doi = {10.1145/3035918.3056418},
   acmid = {3056418},
   publisher = {ACM},
}`
},

{
  "linky":"../data/17-www-carina.pdf",
  "title":"Carina: Interactive Million-Node Graph Visualization Using Web Browser Technologies.",
  "authors": "Fang, D.; Keezer, M.; Williams, J.; Kulkarni, K.; Pienta, R.; and Chau, D. H.",
  "rest": " In Proceedings of the 26th International Conference on World Wide Web Companion  (WWW). Pages 775-776, 2017.",
  "bibtex":`@inproceedings{fang2017carina,
   author = {Fang, Dezhi and Keezer, Matthew and Williams, Jacob and Kulkarni, Kshitij and Pienta, Robert and Chau, Duen Horng},
   title = {Carina: Interactive Million-Node Graph Visualization Using Web Browser Technologies},
   booktitle = {Proceedings of the 26th International Conference on World Wide Web Companion},
   series = {WWW '17 Companion},
   year = {2017},
   isbn = {978-1-4503-4914-7},
   location = {Perth, Australia},
   pages = {775--776},
   numpages = {2},
   url = {https://doi.org/10.1145/3041021.3054234},
   doi = {10.1145/3041021.3054234},
   acmid = {3054234},
   publisher = {International World Wide Web Conferences Steering Committee}
  }`
},

{
  "linky":"../data/17-sdm-facets.pdf",
  "title":"FACETS: Adaptive Local Exploration of Large Graphs.",
  "authors": "Pienta, R.; Kahng, M.; Lin, Z.; Vreeken, J.; Talukdar, P.; Abello, J.; Parameswaran, G.; and Chau, D. H.",
  "rest": " In the Proceedings of the Society for Industrial and Applied Mathematics International Conference on Data Mining (SDM). 2017.",
  "bibtex":`@inproceedings{pienta2017facets,
  title={FACETS: Adaptive Local Exploration of Large Graphs},
  author={Pienta, Robert and Kahng, Minsuk and Lin, Zhiyuan and Vreeken, Jilles and Talukdar, Partha and Abello, James and Parameswaran, Ganesh and Chau, Duen Horng},
  booktitle={Proceedings of the 2017 SIAM International Conference on Data Mining},
  pages={597--605},
  year={2017},
  organization={SIAM}
}`
},

{
  "linky":"../data/16-icmla-fraud.pdf",
  "title":"Uncovering the Landscape of Fraud and Spam in the Telephony Channel.",
  "authors": "Marzuoli, A.; Kingravi, H. A; Dewey, D.; and Pienta, R.",
  "rest": " In the 15th IEEE International Conference on Machine Learning and Applications (ICMLA). 2016.",
  "bibtex":`@inproceedings{marzuoli2016fraud,
  title     = {Uncovering the Landscape of Fraud and Spam in the Telephony Channel},
  author    = {Marzuoli, Aude and Kingravi, Hassan A and Dewey, David and Pienta, Robert},
  booktitle = {Machine Learning and Applications (ICMLA), 2016 15th IEEE International Conference on},
  year      = {2016}
  organization = {IEEE}
  }`
},

{
  "linky":"../data/16-avi-visage.pdf",
  "title":"VISAGE: Interactive Visual Graph Querying.",
  "authors": "Pienta, R.; Tamersoy, A.; Endert, A.; Navathe, S.; Tong, H.; and Chau, D. H.",
  "rest": " In the Proceedings of the 13th International Working Conference on Advanced Visual Interfaces (AVI). 2016.",
  "bibtex":`@inproceedings{pienta2016visage,
    author    = {Robert Pienta and Acar Tamersoy and  Alex Endert and Shamkant Navathe and Hanghang Tong and Duen Horng Chau},
    title     = {VISAGE: Interactive Visual Graph Querying},
    booktitle = {Proceedings of the 13th International Working Conference on Advanced Visual Interfaces, {AVI} 2016 },
    year      = {2016},
  }`
},

{
  "linky":"../data/16-vis-vigor.pdf",
  "title":"Making Sense of Graph Query Results: Interactive Summarization and Exploration (Poster).",
  "authors": "Pienta, R.; Endert, A.; Navathe, S.; and Chau, D. H.",
  "rest": " In Proceedings of the IEEE Visual Analytics Science and Technology (VAST). 2016.",
  "bibtex":`@inproceedings{pienta2016vigor,
    author    = {Robert Pienta and  Alex Endert and Shamkant Navathe and Duen Horng Chau},
    title     = {Making Sense of Graph Query Results: Interactive Summarization and Exploration (Poster)},
    booktitle = {IEEE Visual Analytics Science and Technology, {VAST} 2016 },
    year      = {2016},
  }`
},

{
  "linky":"../data/16-iui-steps.pdf",
  "title":"STEPS: A Spatio-temporal Electric Power Systems Visualization.",
  "authors": "Pienta, R.; Xiong, L.; Grijalva, S.; Chau, D. H.; and Kahng, M.",
  "rest": " In Proceedings of the 20th International Conference on Intelligent User Interfaces Companion (IUI). 2016.",
  "bibtex":`@inproceedings{pienta2016steps,
    author    = {Robert Pienta and Leilei Xiong and Santiago Grijalva and Duen Horng Chau and Minsuk Kahng},
    title     = {STEPS: A Spatio-temporal Electric Power Systems Visualization},
    booktitle = {Proceedings of the 20th International Conference on Intelligent User
                 Interfaces Companion, {IUI} 2016 },
    year      = {2016},
  }`
},

{
  "linky":"../data/16-blackhat-fraud.pdf",
  "title":"Call me: Gathering threat intelligence on telephony scams to detect fraud.",
   "authors": "Marzuoli, A.; Kingravi, H. A; Dewey, D.; Dallas, A.; Calhoun, T.; Nelms, T.; and Pienta,",
   "rest": " Blackhat Security Conference. 2016.",
   "bibtex":`@article{marzuoli2016fraud,
     title     = {Call me: Gathering threat intelligence on telephony scams to detect fraud},
     author    = {Marzuoli, Aude and Kingravi, Hassan A and Dewey, David and Dallas, Aaron and Calhoun, Telvis and Nelms, Terry and Pienta, Robert},
     booktitle = {Blackhat},
     year      = {2016},
   }`
},

{
  "linky":"../data/15-vahc-careflow.pdf",
  "title":"A Visual Analytics Approach to Understanding Care Process Variation and Conformance.",
  "authors": "Basole, R. C.; Park, H.; Gupta, M.; Braunstein, M. L.; Chau, D. H.; Thompson, M.; Kumar, V.; Pienta, R.; and Kahng, M.",
  "rest": " In Proceedings of the Workshop on Visual Analytics in Healthcare (VAHC). 2015.",
  "bibtex":`@inproceedings{basole2105careflow,
    author    = {Rahul C. Basole and Hyunwoo Park and Mayank Gupta and Mark L. Braunstein and Duen Horng Chau and Michael Thompson and Vikas Kumar and Robert Pienta and Minsuk Kahng},
    title     = {A Visual Analytics Approach to Understanding Care Process Variation and Conformance},
    booktitle = {Proceedings of the 2015 Workshop on Visual Analytics in Healthcare (VAHC 2015)},
    year      = {2015},
  }`
},

{
  "linky":"../data/15-kdd-grasp.pdf",
  "title":"GraSP: Distributed Streaming Graph Partitioning.",
  "authors": "Battaglino, C.; Pienta, R.; and Vuduc, R. ",
  "rest": "In KDD Workshop on High Performance Graph Mining, 2015.",
  "bibtex":`@inproceedings{battaglino2015grasp,
    author    = {Casey Battaglino and Robert Pienta and Richard Vuduc},
    title     = {GraSP: Distributed Streaming Graph Partitioning},
    booktitle = {KDD2015 Workshop on High Performance Graph Mining},
    url       = {http://upcommons.upc.edu/handle/2117/76383},
    year      = {2015},
  }`
},

{
  "linky":"../data/15-vis-adaptive.pdf",
  "title":"AdaptiveNav: Adaptive Discovery of Interesting and Surprising Nodes in Large Graphs.",
  "authors": "Pienta, R.; Lin, Z.; Kahng, M.; Vreeken, J.; Talukdar, P. P.; Abello, J.; Parameswaran, G.; and Chau., D. H.",
  "rest": " In Proceedings of the IEEE Visual Analytics Science and Technology (VAST). 2015.",
  "bibtex":`@inproceedings{pienta2015anav,
    author    = {Robert Pienta and Zhiyuan Lin and Minsuk Kahng and Jilles Vreeken and Partha P. Talukdar and James Abello and Ganesh Parameswaran and Duen Horng Chau.},
    title     = {AdaptiveNav: Adaptive Discovery of Interesting and Surprising Nodes in Large Graphs},
    booktitle = {IEEE VIS},
    year      = {2015},
  }`
},

{
  "linky":"../data/15-bigcomp-sensemaking.pdf",
  "title":"Scalable graph exploration and visualization: Sensemaking challenges and opportunities.",
  "authors": "Pienta, R.; Abello, J.; Kahng, M.; and Chau, D. H.",
  "rest": " In International Conference on Big Data and Smart Computing, (BIGCOMP). Pages 271-278, 2015.",
  "bibtex":`@inproceedings{pienta2015sensemaking,
    author    = {Robert Pienta and James Abello and Minsuk Kahng and Duen Horng Chau},
    title     = {Scalable graph exploration and visualization: Sensemaking challenges and opportunities},
    booktitle = {2015 International Conference on Big Data and Smart Computing, {BIGCOMP} 2015, Jeju, South Korea, February 9-11, 2015},
    pages     = {271--278},
    year      = {2015},
    crossref  = {DBLP:conf/bigcomp/2015},
    url       = {http://dx.doi.org/10.1109/35021BIGCOMP.2015.7072812},
    doi       = {10.1109/35021BIGCOMP.2015.7072812},
    timestamp = {Thu, 09 Apr 2015 17:15:02 +0200},
    biburl    = {http://dblp.uni-trier.de/rec/bib/conf/bigcomp/PientaAKC15},
    bibsource = {dblp computer science bibliography, http://dblp.org}
  }`
},

{
  "linky":"../data/15-iui-visage.pdf",
  "title":"Interactive Querying over Large Network Data: Scalability, Visualization, and Interaction Design.",
  "authors": "Pienta, R.; Tamersoy, A.; Tong, H.; Endert, A.; and Chau, D. H.",
  "rest": "In Proceedings of the 20th International Conference on Intelligent User Interfaces Companion (IUI). Pages 61-64, 2015.",
  "bibtex":`@inproceedings{pienta2015previsage,
    author    = {Robert Pienta and Acar Tamersoy and Hanghang Tong and Alex Endert and Duen Horng (Polo) Chau},
    title     = {Interactive Querying over Large Network Data: Scalability, Visualization, and Interaction Design},
    booktitle = {Proceedings of the 20th International Conference on Intelligent User Interfaces Companion, {IUI} 2015, Atlanta, GA, USA, March 29 - April 01, 2015},
    pages     = {61--64},
    year      = {2015},
    crossref  = {DBLP:conf/iui/2015c},
    url       = {http://doi.acm.org/10.1145/2732158.2732192},
    doi       = {10.1145/2732158.2732192},
    timestamp = {Sat, 21 Mar 2015 18:17:54 +0100},
    biburl    = {http://dblp.uni-trier.de/rec/bib/conf/iui/PientaTTEC15},
    bibsource = {dblp computer science bibliography, http://dblp.org}
  }`
},

{
  "linky":"../data/15-www-investor.pdf",
  "title":"Identifying Successful Investors in the Startup Ecosystem.",
  "authors": "Gupta, S.; Pienta, R.; Tamersoy, A.; Chau, D. H.; and Basole., R. C.",
  "rest": " In 2015 IEEE World Wide Web Conference (WWW). 2015.",
  "bibtex":`@inproceedings{investorrank,
    author    = {Srishti Gupta and Robert Pienta and Acar Tamersoy and Duen Horng Chau and Rahul C. Basole.},
    title     = {Identifying Successful Investors in the Startup Ecosystem},
    booktitle = {2015 {IEEE} World Wide Web Conference, Florence Italy},
    year      = {2015},
  }`

},

{
  "linky":"../data/14-bigdata-mage.pdf",
  "title":"MAGE: Matching approximate patterns in richly-attributed graphs.",
   "authors": "Pienta, R.; Tamersoy, A.; Tong, H.; and Chau, D. H.",
   "rest": " In IEEE International Conference on Big Data (BigData). Pages 585-590, 2014.",
   "bibtex":`@inproceedings{pienta2014mage,
     author    = {Robert Pienta and Acar Tamersoy and Hanghang Tong and Duen Horng Chau},
     title     = {{MAGE:} Matching approximate patterns in richly-attributed graphs},
     booktitle = {2014 {IEEE} International Conference on Big Data, Big Data 2014, Washington,
                  DC, USA, October 27-30, 2014},
     pages     = {585--590},
     year      = {2014},
     crossref  = {DBLP:conf/bigdataconf/2014},
     url       = {http://dx.doi.org/10.1109/BigData.2014.7004278},
     doi       = {10.1109/BigData.2014.7004278},
     timestamp = {Tue, 13 Jan 2015 18:18:43 +0100},
     biburl    = {http://dblp.uni-trier.de/rec/bib/conf/bigdataconf/PientaTTC14},
     bibsource = {dblp computer science bibliography, http://dblp.org}
   }`
},

{
  "linky":"../data/14-bigdata-mobilemmap.pdf",
  "title":"Towards scalable graph computation on mobile devices.",
  "authors": "Chen, Y.; Lin, Z.; Pienta, R.; Kahng, M.; and Chau, D. H.",
  "rest": " In IEEE International Conference on Big Data (BigData). Pages 29-35, 2014.",
  "bibtex":`@inproceedings{chen2014mmap,
    author    = {Yiqi Chen and Zhiyuan Lin and Robert Pienta and Minsuk Kahng and Duen Horng Chau},
    title     = {Towards scalable graph computation on mobile devices},
    booktitle = {2014 {IEEE} International Conference on Big Data, Big Data 2014, Washington,
                 DC, USA, October 27-30, 2014},
    pages     = {29--35},
    year      = {2014},
    crossref  = {DBLP:conf/bigdataconf/2014},
    url       = {http://dx.doi.org/10.1109/BigData.2014.7004353},
    doi       = {10.1109/BigData.2014.7004353},
    timestamp = {Tue, 13 Jan 2015 18:18:43 +0100},
    biburl    = {http://dblp.uni-trier.de/rec/bib/conf/bigdataconf/ChenLPKC14},
    bibsource = {dblp computer science bibliography, http://dblp.org}
  }`
},

{
  "linky":"../data/13-wintersim-scalefree.pdf",
  "title":"On the parallel simulation of scale-free networks.",
  "authors": "Pienta, R. S.; and Fujimoto, R. M.",
  "rest": " In SIGSIM Principles of Advanced Discrete Simulation (SIGSIM-PADS). Pages 179-188, 2013.",
  "bibtex":`@inproceedings{pienta2013scalefree,
    author    = {Robert S. Pienta and
                 Richard M. Fujimoto},
    title     = {On the parallel simulation of scale-free networks},
    booktitle = {{SIGSIM} Principles of Advanced Discrete Simulation, {SIGSIM-PADS}
                 '13, Montreal, QC, Canada, May 19-22, 2013},
    pages     = {179--188},
    year      = {2013},
    crossref  = {DBLP:conf/pads/2013},
    url       = {http://doi.acm.org/10.1145/2486092.2486115},
    doi       = {10.1145/2486092.2486115},
    timestamp = {Fri, 26 Sep 2014 14:02:17 +0200},
    biburl    = {http://dblp.uni-trier.de/rec/bib/conf/pads/PientaF13},
    bibsource = {dblp computer science bibliography, http://dblp.org}
  }`
},

{
  "linky":"../data/12-isvc-face.pdf",
  "title":"A Comparative Analysis of Thermal and Visual Modalities for Automated Facial Expression Recognition.",
  "authors": "Wesley, A.; Buddharaju, P.; Pienta, R.; and Pavlidis, I.",
  "rest": " In Advances in Visual Computing - 8th International Symposium (ISVC). Pages 51-60, 2012.",
  "bibtex":`@inproceedings{wesley2012face,
    author    = {Avinash Wesley and
                 Pradeep Buddharaju and
                 Robert Pienta and
                 Ioannis Pavlidis},
    title     = {A Comparative Analysis of Thermal and Visual Modalities for Automated
                 Facial Expression Recognition},
    booktitle = {Advances in Visual Computing - 8th International Symposium, {ISVC}
                 2012, Rethymnon, Crete, Greece, July 16-18, 2012, Revised Selected
                 Papers, Part {II}},
    pages     = {51--60},
    year      = {2012},
    crossref  = {DBLP:conf/isvc/2012-2},
    url       = {http://dx.doi.org/10.1007/978-3-642-33191-6_6},
    doi       = {10.1007/978-3-642-33191-6_6},
    timestamp = {Mon, 27 Aug 2012 07:56:05 +0200},
    biburl    = {http://dblp.uni-trier.de/rec/bib/conf/isvc/WesleyBPP12},
    bibsource = {dblp computer science bibliography, http://dblp.org}
  }`
}
];

export default pubs;



// WEBPACK FOOTER //
// ./src/layouts/bibly.js